import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  useMassUpdateServiceRequired,
  usePopupManager
} from 'ui-builder';
import { MassRoadmapForm } from 'features/tasks-list-feature';

export default function MakeRoadmapButton() {
  const massUpdateService = useMassUpdateServiceRequired();

  const popupManager = usePopupManager();

  const onClick = () => {
    popupManager.openPopup(
      <MassRoadmapForm />,
    );
  };

  return (
    <Button
      text="Roadmap"
      isDisabled={massUpdateService.getCheckedIds().length === 0}
      color={ButtonColor.DARK_BLUE}
      size={ButtonSize.SMALL}
      isFlat
      variant={ButtonVariant.FILLED}
      onClick={onClick}
    />
  );
}
